import { isEqual } from 'lodash'
import { action, makeAutoObservable, observable } from 'mobx'

import { Pvz } from '../entity/Pvz'
import { ViewPvzUiStore } from '../ViewPvz/ViewPvzUiStore'
import { InitialAreaModelStateType } from './types'

export class PvzAreaViewModel {
  @observable area = ''
  @observable warehouseArea = ''

  @observable initialized = false

  private initialState: InitialAreaModelStateType | null = null

  constructor(protected readonly uiStore: ViewPvzUiStore) {
    makeAutoObservable(this)
  }

  get isNoChanges() {
    return isEqual(this.initialState, this.hashFormState)
  }

  get isAreaWasChanged() {
    return this.initialState?.area !== this.area.toString()
  }

  get invalidEditAreaDocuments() {
    return this.isAreaWasChanged && this.uiStore.fileList.documentsForEditArea.some((document) => !document.url)
  }

  get hashFormState(): InitialAreaModelStateType {
    const fileList = this.uiStore.fileList

    return {
      area: this.area.toString(),
      warehouseArea: this.warehouseArea.toString(),
      documents: fileList.documentsForEditArea.map((document) => document.url),
    }
  }

  init(pvz: Pvz) {
    this.setArea(pvz.area)
    this.setWarehouseArea(pvz.warehouseArea)
    this.setInitialState(this.hashFormState)
    this.setInitialized(true)
  }

  @action
  setArea = (value: string) => {
    this.area = value
  }

  @action
  setWarehouseArea = (value: string) => {
    this.warehouseArea = value
  }

  @action
  setInitialState = (value: InitialAreaModelStateType) => {
    this.initialState = value
  }

  @action
  setInitialized(value: boolean) {
    this.initialized = value
  }
}
